// extracted by mini-css-extract-plugin
export default {"CustomInput":"style_CustomInput__0Px8R"};